<template>
  <div class='interactives-will-input'>
    <button class="back-button" @click="$emit('back')">« Back</button>
    <div class="will-input-body">
        <p class="will-disclaimer"><em>This document is <strong>not legally binding or enforceable</strong>.</em></p>
        <p>
            I, <custom-input
                :inputData="templateData.userName"
                v-model="templateData.userName.value"
            /> of <custom-input
                :inputData="templateData.userResidence"
                v-model="templateData.userResidence.value"
            />, establish this as my digital will, laying out my preferences for the future use of my online accounts.
        </p>
        <p>
            I appoint <custom-input
                :inputData="templateData.execName"
                v-model="templateData.execName.value"
            /> of <custom-input
                :inputData="templateData.execResidence"
                v-model="templateData.execResidence.value"
            /> as the sole executor of this will.
        </p>
        <p>
            Where appropriate and necessary, passwords and other login credentials will be provided to my executor via separate documentation.
        </p>
        <p>
            I give my executor the following duties and responsibilities:
        </p>
        <div v-show="formData[2].value">
            <h3>
                Web browsing history
            </h3>
            <p>
                Delete the entire browsing history from all browsers on my computer.
            </p>
        </div>
        <div v-show="selected('Email')">
            <h3>
                Email
            </h3>
            <p>
                I employ <custom-input
                    :inputData="templateData.email[0]"
                    v-model="templateData.email[0].value"
                />. Within 30 days of my death, I request that my executor access that account using the login credentials provided via supplementary documentation. They should then:
                <div> 
                    <custom-input
                        :inputData="templateData.email[1]"
                        v-model="templateData.email[1].value"
                    />
                </div>
            </p>
        </div>
        <div v-show="selected('Facebook')">
            <h3>
                Facebook
            </h3>
            <p>
                I maintain a Facebook account under <custom-input
                    :inputData="templateData.facebook[0]"
                    v-model="templateData.facebook[0].value"
                />. Within 30 days of my death, I request that my executor <custom-input
                    :inputData="templateData.facebook[1]"
                    v-model="templateData.facebook[1].value"
                />.
            </p>
        </div>
        <div v-show="selected('Twitter')">
            <h3>
                Twitter
            </h3>
            <p>
                I maintain a Twitter account under
                <custom-input
                    :inputData="templateData.twitter[0]"
                    v-model="templateData.twitter[0].value"
                />
                <span
                    v-show="templateData.twitter[0].value == 'the handle'"
                > 
                    @<custom-input
                        :inputData="templateData.twitter[1]"
                        v-model="templateData.twitter[1].value"
                    />
                </span>
                . Within 30 days of my death, I request that my executor 
                <custom-input
                    :inputData="templateData.twitter[2]"
                    v-model="templateData.twitter[2].value"
                />.
            </p>
        </div>
        <div v-show="selected('Amazon')">
            <h3>
                Amazon
            </h3>
            <p>
                I maintain an Amazon account under <custom-input
                    :inputData="templateData.amazon[0]"
                    v-model="templateData.amazon[0].value"
                />. Where allowed, I grant and transfer ongoing ownership of all e-books, digital movies, and music associated with that account to <custom-input
                    :inputData="templateData.amazon[1]"
                    v-model="templateData.amazon[1].value"
                />. In addition, I request that my executor access my account and:
                <div> 
                    <custom-input
                        :inputData="templateData.amazon[2]"
                        v-model="templateData.amazon[2].value"
                    />
                </div>
            </p>
        </div>
        <div v-show="selected('iTunes')">
            <h3>
                iTunes
            </h3>
            <p>
                I maintain an iTunes account under <custom-input
                    :inputData="templateData.itunes[0]"
                    v-model="templateData.itunes[0].value"
                />. Where allowed, I grant and transfer ongoing ownership of all digital content associated with that account to <custom-input
                    :inputData="templateData.itunes[1]"
                    v-model="templateData.itunes[1].value"
                />.
            </p>
        </div>
        <div v-for="(service, index) in formData[1].value">
            <h3>
                {{ service }}
            </h3>
            <p>
                I maintain an account with {{ service }} under the login <custom-input
                    :inputData="templateData.additional[service][0]"
                    v-model="templateData.additional[service][0].value"
                />. I request that my executor do the following with that account:
                <div>
                    <custom-input
                        :inputData="templateData.additional[service][1]"
                        v-model="templateData.additional[service][1].value"
                    />
                </div>
                <div>
                    <p>
                        <custom-input
                            :inputData="templateData.additional[service][2]"
                            v-model="templateData.additional[service][2].value"
                        />
                    </p>
                </div>
                In addition,
                <div>
                    <custom-input
                        :inputData="templateData.additional[service][3]"
                        v-model="templateData.additional[service][3].value"
                    />    
                </div>
            </p>
        </div>
    </div>
    <div class="cont-btn-c"><button class="continue-button" @click="$emit('submitForm')">Continue</button></div>
  </div>
</template>

<script>
import * as $ from 'jquery'
import Input from '../../../interactives-input/src/App.vue'

export default {
  name: 'interactives-will-input',
  props: ['formData', 'templateData'],
  components: {
    'custom-input': Input
  },
  mounted () {
    $('input[placeholder]').each(function () {
      $(this).attr('size', $(this).attr('placeholder').length)
    })
  },
  methods: {
    selected (string) { return $.inArray(string, this.formData[0].value) > -1 }
  }
}
</script>

<style lang="scss">
.interactives-will-input {
  .interactives-input {
      display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WillInput.vue